import Auth from './auth';
import Page404 from './404';

export default {
  Auth,
  Page404,
};
